import { groupBy, sortBy } from 'lodash';
import { createSelector } from 'reselect';

import { State } from '.';

const SORT_TITLE_REGEX = /^(the|a)\s+/i;

export const selectAllShows = (state: State) => state.showsIndex.shows;
export const selectFeaturedShows = (state: State) => state.showsIndex.featuredShows;
export const selectHeroStream = (state: State) => state.showsIndex.hero.liveNotification.videoID || state.showsIndex.hero.stream;
export const selectHeroTitle = (state: State) => state.showsIndex.hero.liveNotification.title;
export const selectHeroURL = (state: State) => state.showsIndex.hero.url;
export const selectHeroLiveStatus = (state: State) => state.showsIndex.hero.liveNotification.isReplay === false;
export const selectMetadata = (state: State) => state.showsIndex.metadata;

export const selectSortedShows = (state: State) => sortBy(
    state.showsIndex.shows,
    show => show.title.replace(SORT_TITLE_REGEX, '').toLowerCase(),
);

export const selectShowsByLetter = createSelector(
    selectSortedShows,
    shows => groupBy(shows, show => {
        const firstLetter = show.title.replace(SORT_TITLE_REGEX, '').charAt(0).toUpperCase();
        return firstLetter.match(/^[^a-z]/i) ? '#' : firstLetter;
    }),
);

export const selectShowsLetters = createSelector(
    selectShowsByLetter,
    showsMap => Object.keys(showsMap).sort(),
);

export const selectSelectedLetter = createSelector(
    selectShowsLetters,
    state => state.showsIndex.ui.selectedLetter,
    (letters, selectedLetter) => letters.indexOf(selectedLetter) !== -1 ? selectedLetter : undefined,
);

export const selectSelectedShowsByLetter = createSelector(
    selectSelectedLetter,
    selectShowsByLetter,
    (letter, showsByLetter) => letter ? showsByLetter[letter] : [],
);
